var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path4, _path5, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 294.27 322.1",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 219.04,
    y1: 101.03,
    x2: 230.3,
    y2: 546.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 77.37,
    y1: 104.91,
    x2: 63.11,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 86.57,
    y1: 104.91,
    x2: 72.31,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 95.77,
    y1: 104.91,
    x2: 81.5,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 124.67,
    y1: 104.91,
    x2: 110.41,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 133.87,
    y1: 104.91,
    x2: 119.61,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 143.07,
    y1: 104.91,
    x2: 128.8,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 188.58,
    y1: 104.91,
    x2: 174.32,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 197.78,
    y1: 104.91,
    x2: 183.51,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 206.98,
    y1: 104.91,
    x2: 192.71,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 235.88,
    y1: 104.91,
    x2: 221.62,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 245.08,
    y1: 104.91,
    x2: 230.81,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 254.28,
    y1: 104.91,
    x2: 240.01,
    y2: 143.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 77.37,
    y1: 231.42,
    x2: 63.11,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 86.57,
    y1: 231.42,
    x2: 72.31,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 95.77,
    y1: 231.42,
    x2: 81.5,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 124.67,
    y1: 231.42,
    x2: 110.41,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 133.87,
    y1: 231.42,
    x2: 119.61,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 143.07,
    y1: 231.42,
    x2: 128.8,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 188.58,
    y1: 231.42,
    x2: 174.32,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 197.78,
    y1: 231.42,
    x2: 183.51,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 206.98,
    y1: 231.42,
    x2: 192.71,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 235.88,
    y1: 231.42,
    x2: 221.62,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 245.08,
    y1: 231.42,
    x2: 230.81,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 254.28,
    y1: 231.42,
    x2: 240.01,
    y2: 269.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 240.06,
    y1: 36.52,
    x2: 124.25,
    y2: 97.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 174.18,
    y1: 55.74,
    x2: 76.57,
    y2: 107.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 101.63,
    y1: 524.89,
    x2: 108.39,
    y2: -149.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 102.04,
    y1: 524.89,
    x2: 108.8,
    y2: -149.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 102.45,
    y1: 524.89,
    x2: 109.21,
    y2: -149.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 210.85,
    y1: 525.98,
    x2: 217.61,
    y2: -148.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 211.27,
    y1: 525.98,
    x2: 218.03,
    y2: -148.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 211.68,
    y1: 525.99,
    x2: 218.44,
    y2: -148.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 167.49,
    y1: 91.56,
    x2: 166.93,
    y2: 310.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 276.73,
    y1: 91.56,
    x2: 276.17,
    y2: 310.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 167.49,
    y1: 132.85,
    x2: 166.93,
    y2: 351.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 276.73,
    y1: 132.85,
    x2: 276.17,
    y2: 351.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 167.49,
    y1: 174.15,
    x2: 166.93,
    y2: 392.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 276.73,
    y1: 174.15,
    x2: 276.17,
    y2: 392.62,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Data hosting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M326.79,58c-1.93-26.07-22.17-49.75-47.63-55.71-23-5.39-47,2.63-70.56.83C199.45,2.41,190.45.23,181.28,0a65.74,65.74,0,0,0-52.57,24.76C114.05,43.45,104,66.61,101.46,90.24c-7.64,72.5-34.65,90.62-37.9,111.3C51,281.36,133,318.62,198.1,321.91c59.39,3,138.76-34.56,148.73-47.31,14.44-18.45,10.24-64.75,3.77-87.26-5.18-18-13.21-36-14.74-54.88-1.27-15.65.21-24.88-5.95-40.38C325.61,81.26,327.63,69.31,326.79,58Z",
    transform: "translate(-62.28 0.03)",
    fill: "#1e3a8a",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M332.38,120.31a39.3,39.3,0,0,1-39.31,39.32h-147a39.3,39.3,0,0,1-1.93-78.56,37.86,37.86,0,0,1,37.25-31.33h5.05a38,38,0,0,1,24.09,8.64A45.47,45.47,0,0,1,298.32,75a33.23,33.23,0,0,1-.53,6.32A39.29,39.29,0,0,1,332.38,120.31Z",
    transform: "translate(-62.28 0.03)",
    fill: "#1e3a8a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.38,120.31a39.3,39.3,0,0,1-39.31,39.32h-147a39.3,39.3,0,0,1-1.93-78.56,37.86,37.86,0,0,1,37.25-31.33h5.05a38,38,0,0,1,24.09,8.64A45.47,45.47,0,0,1,298.32,75a33.23,33.23,0,0,1-.53,6.32A39.29,39.29,0,0,1,332.38,120.31Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.82,109a36.82,36.82,0,0,1-11.43,26.65,39.65,39.65,0,0,1-27.61,11h-146c-21.59,0-39.1-16.83-39.1-37.68a36.93,36.93,0,0,1,11.43-26.65,39.52,39.52,0,0,1,25.76-11A35.52,35.52,0,0,1,155.34,52a38.1,38.1,0,0,1,26.55-10.65h5a38.52,38.52,0,0,1,23.91,8.29c6.54-16.19,22.85-27.67,42-27.67,25,0,45.18,19.51,45.18,43.61a30.63,30.63,0,0,1-.53,6.06C316.83,73.87,331.82,89.74,331.82,109Z",
    transform: "translate(-62.28 0.03)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.7,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.1,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-4)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-5)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-6)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 134.4,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-7)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 179.91,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-8)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 189.11,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-9)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 198.31,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-10)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 227.21,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-11)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 236.41,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-12)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 245.61,
    y: 112.65,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-13)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 68.7,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-14)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-15)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 87.1,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-16)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-17)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 125.2,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-18)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 134.4,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-19)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 179.91,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-20)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 189.11,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-21)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 198.31,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-22)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 227.21,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-23)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 236.41,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-24)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 245.61,
    y: 239.15,
    width: 4.5,
    height: 19.14,
    rx: 2.25,
    fill: "url(#linear-gradient-25)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.82,49.64l10.26,10.61S227.46,22,267.63,24.59C267.63,24.59,229.83,11.25,210.82,49.64Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-26)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.9,71.38s7.3-.8,14.24,7.64c0,0,1.5-34.16,30.5-34.72,0,0-11.88-7.59-28.43,3.1C146.38,57,144.9,71.38,144.9,71.38Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-27)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 131.65,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 173,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 213.92,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 164.24,
    y: 131.65,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 164.24,
    y: 173,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 164.24,
    y: 213.92,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 131.65,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "url(#linear-gradient-28)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 173,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "url(#linear-gradient-29)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 213.92,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "url(#linear-gradient-30)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 164.24,
    y: 131.65,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "url(#linear-gradient-31)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 164.24,
    y: 173,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "url(#linear-gradient-32)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 164.24,
    y: 213.92,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "url(#linear-gradient-33)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 55.24,
    y: 124.8,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 55.24,
    y: 166.15,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 55.24,
    y: 207.07,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 124.8,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 166.15,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 207.07,
    width: 100.79,
    height: 34.24,
    rx: 11.07,
    fill: "#1e3a8a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.29,142.69H217.8v-9.14s-.56-7.7-10.56-8.78H126.86S114.75,127.63,117.29,142.69Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-34)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.52,142.69H327v-9.14s-.55-7.7-10.55-8.78H236.1S224,127.63,226.52,142.69Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-35)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.29,184H217.8v-9.15s-.56-7.7-10.56-8.78H126.86S114.75,168.92,117.29,184Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-36)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.52,184H327v-9.15s-.55-7.7-10.55-8.78H236.1S224,168.92,226.52,184Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-37)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.29,225.28H217.8v-9.15s-.56-7.7-10.56-8.77H126.86S114.75,210.21,117.29,225.28Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-38)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.52,225.28H327v-9.15s-.55-7.7-10.55-8.77H236.1S224,210.21,226.52,225.28Z",
    transform: "translate(-62.28 0.03)",
    fill: "url(#linear-gradient-39)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.58,
    cy: 142.16,
    r: 3.52,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.53,
    cy: 142.16,
    r: 3.52,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.47,
    cy: 142.16,
    r: 3.52,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.07,
    cy: 142.16,
    r: 3.52,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.02,
    cy: 142.16,
    r: 3.52,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.97,
    cy: 142.16,
    r: 3.52,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.58,
    cy: 184.16,
    r: 3.52,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.53,
    cy: 184.16,
    r: 3.52,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.47,
    cy: 184.16,
    r: 3.52,
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.07,
    cy: 184.16,
    r: 3.52,
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.02,
    cy: 184.16,
    r: 3.52,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.97,
    cy: 184.16,
    r: 3.52,
    fill: "#fff"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.58,
    cy: 226.16,
    r: 3.52,
    fill: "#fff"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.53,
    cy: 226.16,
    r: 3.52,
    fill: "#fff"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.47,
    cy: 226.16,
    r: 3.52,
    fill: "#fff"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.07,
    cy: 226.16,
    r: 3.52,
    fill: "#fff"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 240.02,
    cy: 226.16,
    r: 3.52,
    fill: "#fff"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.97,
    cy: 226.16,
    r: 3.52,
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.b755d3eebb287dde8fcd287cb1d5653e.svg";
export { ForwardRef as ReactComponent };